// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4ea24f04","234":"bc72fa83","361":"7d9510fe","454":"da6bcc56","530":"9231f556"}[chunkId] + ".chunk.js";
};